<template>
<!--  <b-nav-item-dropdown-->
<!--      id="dropdown-grouped"-->
<!--      variant="link"-->
<!--      class="dropdown-language"-->
<!--      right-->
<!--      style="list-style: none"-->
<!--  >-->
<!--    <template #button-content>-->
<!--      <b-img-->
<!--          :src="currentLocale.img"-->
<!--          height="14px"-->
<!--          width="22px"-->
<!--          :alt="currentLocale.locale"-->
<!--      />-->
<!--      <span class="ml-50 text-body">{{ currentLocale.name }}</span>-->
<!--    </template>-->
<!--    <b-dropdown-item-->
<!--        v-for="localeObj in locales"-->
<!--        :key="localeObj.locale"-->
<!--        @click="localeChanged(localeObj.locale)"-->
<!--    >-->
<!--      <b-img-->
<!--          :src="localeObj.img"-->
<!--          height="14px"-->
<!--          width="22px"-->
<!--          :alt="localeObj.locale"-->
<!--      />-->
<!--      <span class="ml-50">{{ localeObj.name }}</span>-->
<!--    </b-dropdown-item>-->
<!--  </b-nav-item-dropdown>-->
</template>

<script>
import {BNavItemDropdown, BDropdownItem, BImg} from "bootstrap-vue";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find((l) => l.locale === this.$i18n.locale);
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: "en",
        img: require("@/assets/images/flags/en.png"),
        name: "English",
      },
      {
        locale: "fa",
        img: require("@/assets/images/flags/fa.png"),
        name: "فارسی",
      },
    ];
    /* eslint-disable global-require */

    return {
      locales,
    };
  },
  methods: {
    localeChanged(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale",locale);
      this.$router.push({
        name: this.$route.name,
        params: {
          lang: locale
        }
      })
      if (locale == "fa") {
        this.$store.commit("appConfig/SET_RTL", true);
      } else {
        this.$store.commit("appConfig/SET_RTL", false);
      }
    },
  },
};
</script>

<style>
</style>
